import { useEffect, useState } from "react";
import { _EmployeeContract } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { MigrateEmployeeLiquidate } from "./MigrateEmployeeLiquidate";
import { ExcecuteRemoteAbstract } from "../../system/remoteAbstractAction/ExcecuteRemoteAbstract";
import { PrintJson } from "../../theme/Component/PrintJson";

export const ProfileEmployeeLiquidate = () => {

    const _employeeContracts = useDataBean(_EmployeeContract);
    const { lista, setLista, bean, setBean } = _employeeContracts;
    const modalModelo = useModal("Migrar modelo desde XML", MODAL_LG);
    const modalProfile = useModal("Configurar Propiedades del Perfil", MODAL_LG);

    useEffect(() => {
        _employeeContracts.instance.getEmployeeLiquidateList(null).then((resp: any) => {
            setLista(resp);
        }).catch(err => toast.warning(err))
    }, [])

    const head = [
        { title: 'ID', property: 'IDEmployeeLiquidate', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: 'Migrar modelo desde XML', icono: 'ri-edit-2-line', visible: true, evento: () => { modalModelo.open() } },
            // { titulo: 'Configurar Tipos de Entidades de SeguridadSocial', icono: 'ri-edit-2-line', visible: true, evento: () => { modalConfigurar.open() } },
            { titulo: 'Configurar Propiedades del Perfil', icono: 'ri-edit-2-line', visible: true, evento: () => { getRemote() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const getRemote = () => {
        _employeeContracts.instance.getPayrollLiquidateProfileEditor(null).then(
            (resp) => {
                modalProfile.open()
                console.log(resp)
                setRemote(resp);
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [remote, setRemote] = useState<any>({});

    return (
        <BasicPage titulo="Tipos de Perfiles de Nómina">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} body={lista} head={head} rowSet={setBean}></BasicTable>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalModelo.modal} updateModal={modalModelo.setModal}>
                        <div className="row">
                            <div className="col">
                                <MigrateEmployeeLiquidate employeeLiquidate={bean} />
                            </div>
                        </div>
                    </Modal>
                    
                    <Modal modal={modalProfile.modal} updateModal={modalProfile.setModal}>
                        <div className="row">
                            <div className="col">
                                {remote.IDRemoteAbstractAction &&

                                    <ExcecuteRemoteAbstract remoteAbstractAction={remote} mapData={{ IDEmployeeLiquidate: bean.IDEmployeeLiquidate }} />
                                }
                                {/* <PrintJson json={remote} /> */}
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}